<template>
    <div class="gw_product3">
      <!--banner-->
      <div class="bannerBox">
        <div class="banner">
          <div class="mainContainer">
            <p class="titleBig gw_fadeInUp gw_animateDelay_01">专家服务</p>
            <p class="gw_fadeInUp gw_animateDelay_02">专家服务是牛盾为客户提供的“专家式”人工服务，帮助客户预防、监测、发现主机、站点及系统的安全风险，给出解决方案、整改建议及权威报告，并及时修复被攻击系统，降低损失。</p>
            <button class="btns" @click="goU">立即申请</button>
          </div>
        </div>
      </div>
      <!--服务内容-->
      <div class="mainContainer serviceCon" id="gw_animate3Box1">
        <p class="title">服务内容</p>
        <ul class="clearFloat">
          <li class="flex">
            <div class="icons icons1">
              <i></i>
              <p>安全咨询</p>
            </div>
            <div class="iconTxt">
              <span class="gw_fadeInUp gw_animateDelay_03">协助企业识别信息资产及业务流程的信息安全弱点，并针对信息安全威胁提供信息安全风险处理规划建议。安全咨询包括合规类咨询服务、安全管理咨询服务、与行业安全解决方案咨询服务。</span>
            </div>
          </li>
          <li class="flex">
            <div class="icons icons2">
              <i></i>
              <p>应急响应</p>
            </div>
            <div class="iconTxt">
              <span class="gw_fadeInUp gw_animateDelay_03">当客户系统遭受病毒传播、网络攻击等安全事件从而导致信息业务中断、系统宕机、网络瘫痪，并对组织和业务运行产生直接或间接的负面影响时，由牛盾安全专家及时为您提供解决方案。</span>
            </div>
          </li>
          <li class="flex">
            <div class="icons icons3">
              <i></i>
              <p>现场值守</p>
            </div>
            <div class="iconTxt">
              <span :class="{gw_fadeInUp:isUp1,gw_isShow:isShow1}">在特定的业务场景，为您提供防护咨询、安全设备监控、安全巡检、安全事件分析、应急处置等专业、安全的现场值守服务项目，为您的重要业务活动保驾护航。</span>
            </div>
          </li>
          <li class="flex">
            <div class="icons icons4">
              <i></i>
              <p>安全加固</p>
            </div>
            <div class="iconTxt">
              <span :class="{gw_fadeInUp:isUp1,gw_isShow:isShow1}">在客户授权的情况下，对客户主机、网络设备、应用系统、操作系统、数据库等进行全面的基线加固和组件升级，针对系统的安全隐患等提供安全加固方案，整体上提高系统的安全防御能力。</span>
            </div>
          </li>
        </ul>
      </div>
      <!--应用场景-->
      <div class="mainContainer" id="gw_animate3Box2">
        <p class="title">应用场景</p>
        <div class="scene flex_space">
          <div class="boxs">
            <div class="boxs_top flex">
              <div class="icons"><i></i></div>
              <div class="iconTxt" :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2}">
                <div>安全体检</div>
                <p>新业务站点上线，易受到来自互联网的各类攻击，造成网页篡改、数据泄露、服务挂起等风险，因此在业务系统上线前有必要进行安全风险体检，根据体检结果进行安全整改，免遭黑客入侵。</p>
              </div>
            </div>
            <div class="boxs_mid flex_align">
              <div>精准防护</div>
              <div>专业解读</div>
              <div>方式多样</div>
            </div>
            <div class="boxs_bottom">
              <div :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2,gw_animateDelay_01:isUp2}">
                丰富的安全对抗经验，可协助用户输出可全面高效、精准防护策略，快速解决用户痛点问题。
              </div>
              <p></p>
              <div :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2,gw_animateDelay_02:isUp2}">
                资深安全专家，直接对接用户，解答网站安全问题，提供最安全便捷的解决方案。
              </div>
              <p></p>
              <div :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2,gw_animateDelay_03:isUp2}">
                针对不同的客户体检模式，贴合您的不同场景需求，为您人性化输出漏洞情况。
              </div>
            </div>
          </div>
          <div class="boxs">
            <div class="boxs_top flex">
              <div class="icons"><i></i></div>
              <div class="iconTxt" :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2}">
                <div>应急响应</div>
                <p>科技日新月异，安全漏洞层出不穷，一旦爆发类似勒索病毒之类的突发安全事件，企业应该及时排查自身的漏洞，安装新的补丁以抵御入侵。牛盾提供为您提供入侵原因分析、业务损失评估、系统恢复加固、以及黑客溯源取证的安全服务，减少因黑客入侵带来的损失。</p>
              </div>
            </div>
            <div class="boxs_mid flex_align">
              <div>业务止损</div>
              <div>入侵分析</div>
              <div>实时响应</div>
            </div>
            <div class="boxs_bottom">
              <div :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2,gw_animateDelay_01:isUp2}">
                清除恶意软件，阻止黑客进一步攻击，对安全漏洞进行加固，协助客户尽快恢复业务的正常服务。
              </div>
              <p></p>
              <div :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2,gw_animateDelay_02:isUp2}">
                专家分析安全事件类型，分析入侵路径；清理木马病毒、WebShell 后门、黑客工具等威胁内容。
              </div>
              <p></p>
              <div :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2,gw_animateDelay_03:isUp2}">
                以最快的速度对客户业务进行接入，避免继续造成损失，制定正确应对措施，帮助客户快速恢复业务。
              </div>
            </div>
          </div>
          <div class="boxs">
            <div class="boxs_top flex">
              <div class="icons"><i></i></div>
              <div class="iconTxt" :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2}">
                <div>安全加固</div>
                <p>在客户授权的情况下，对客户主机、网络设备、应用系统、操作系统、中间件、数据库等进行全面的基线加固和组件升级，针对系统存在的高危漏洞和安全隐患等提供安全加固方案，整体上提高系统的安全防御能力。 </p>
              </div>
            </div>
            <div class="boxs_mid flex_align">
              <div>量身定制</div>
              <div>全面性</div>
              <div>值得信赖</div>
            </div>
            <div class="boxs_bottom">
              <div :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2,gw_animateDelay_01:isUp2}">
                专业的团队提供专业的安全加固方案，在实施前充分讨论，结合客户实际业务情况，按需加固。
              </div>
              <p></p>
              <div :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2,gw_animateDelay_02:isUp2}">
                对操作系统、网络设备、安全设备、数据库、应用系统，提出安全有效加固方案和服务。
              </div>
              <p></p>
              <div :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2,gw_animateDelay_03:isUp2}">
                权威安全专家审核检测，对加固进行有效证验证，确保安全加固效果到位。
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--价值体现-->
      <div class="valueCon" id="gw_animate3Box3">
        <p class="title">价值体现</p>
        <div class="boxs flex_space">
          <div class="boxs_detail boxs_detail1">
            <div class="content">
              <div>
                商业价值
              </div>
              <p :class="{gw_fadeInUp:isUp3,gw_isShow:isShow3}">能够为个人和企业预警安全风险，并提出可行的安全策略，减少不必要的安全投入，从而避免安全问题带来的直接经济损失和重复的资源浪费。</p>
            </div>
          </div>
          <div class="boxs_detail boxs_detail2">
            <div class="content">
              <div>
                技术价值
              </div>
              <p :class="{gw_fadeInUp:isUp3,gw_isShow:isShow3}">提升现有安全防护能力，帮助客户分担风险，保障业务高可用，避免公司因为监管需求和合规要求等带来的产品销售受限，无法开展相应业务等问题。</p>
            </div>
          </div>
          <div class="boxs_detail boxs_detail3">
            <div class="content">
              <div>
                品牌价值
              </div>
              <p :class="{gw_fadeInUp:isUp3,gw_isShow:isShow3}">保护公司品牌免收黑客入侵、数据泄露、产品安全和人身安全等带来的企业负面影响，协助公司树立安全可靠的品牌形象。</p>
            </div>
          </div>
        </div>
      </div>
      <!--行业案例-->
      <div class="BusinessCase">
        <div>
          <Case></Case>
        </div>
      </div>
      <!--footer-->
      <div class="gw_homefooterBox">
        <footBar></footBar>
      </div>
      <!--返回顶部-->
      <returnTop></returnTop>
    </div>
</template>

<script>
  import footBar from '../../components/footerbar';
  import returnTop from '../../components/returnTop';
  import Case from '../../components/case';
    export default {
      name: "ExpertService",
      data(){
        return{
          isUp1:false,
          isShow1:true,
          isUp2:false,
          isShow2:true,
          isUp3:false,
          isShow3:true
        }
      },
      components:{
        footBar,Case,returnTop
      },
      mounted(){
        window.addEventListener('scroll',this.scrollFuns);
      },
      destroyed(){
        window.removeEventListener('scroll',this.scrollFuns);
      },
      methods:{
        scrollFuns(){
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          let gw_animateBox1 = document.getElementById('gw_animate3Box1');
          let gw_animateBox2 = document.getElementById('gw_animate3Box2');
          let gw_animateBox3 = document.getElementById('gw_animate3Box3');
          // console.log('scrollTop=',gw_animateBox1.offsetTop-scrollTop);
          let top_value1 = gw_animateBox1.offsetTop-scrollTop;
          let top_value2 = gw_animateBox2.offsetTop-scrollTop;
          let top_value3 = gw_animateBox3.offsetTop-scrollTop;
          if(top_value1<=520){
            this.isUp1 = true;
            this.isShow1 = false;
          }
          if(top_value2<=560){
            this.isUp2 = true;
            this.isShow2 = false;
          }
          if(top_value3<=520){
            this.isUp3 = true;
            this.isShow3 = false;
          }
        },
        goU(){
          this.$router.push({name:'startApply',params:{product:1,title:'专家服务'}})
        },
      }
    }
</script>

<style scoped lang="scss">
   @mixin transtion_me($option,$second,$timing){
     transition: $option $second $timing;
     -moz-transition: $option $second $timing; /* Firefox 4 */
     -webkit-transition: $option $second $timing; /* Safari 和 Chrome */
     -o-transition: $option $second $timing; /* Opera */
   }
   @mixin  transform_me($option){
     transform: $option;
     -ms-transform:$option; 	/* IE 9 */
     -moz-transform:$option; 	/* Firefox */
     -webkit-transform:$option; /* Safari 和 Chrome */
     -o-transform:$option;
   }
   @mixin transitionAll03 {
     -o-transition: all 0.3s;
     -moz-transition: all 0.3s;
     -webkit-transition: all 0.3s;
     transition: all 0.3s;
   }
   .gw_product3{
     .bannerBox {
       .banner {
         background: url("../../assets/img/product3/banner.jpg") no-repeat center;
         background-size: cover;
       }
     }
     .mainContainer,.valueCon{
       padding-top:70px;
       .title{
         font-size: 24px;
         color: #000000;
         font-family: 'pingfangBold';
         font-weight: normal;
         margin-bottom:35px;
       }
     }
     .valueCon{
       width:1320px;
       margin:0 auto;
       padding-bottom:70px;
       .boxs{
         .boxs_detail{
           width:420px;
           height:300px;
           .content{
             padding:24px 52px 0 31px;
             text-align: left;
             div{
               font-size: 24px;
               color: #FFFFFF;
               /*transform: translate3d(0,0,0);*/
               @include transform_me(translate3d(0,0,0));
             }
             p{
               font-size: 14px;
               color: #FFFFFF;
               margin-top:41px;
               /*transform: translate3d(0,0,0);*/
               @include transform_me(translate3d(0,0,0));
             }
           }
           @include transtion_me(all,0.5s,linear);
           &:hover{
             /*transform: scale(1.05);*/
             @include transform_me(scale(1.05));
             .content{
               div,p{
                 /*transform: translate3d(0,0,0);*/
                 @include transform_me(translate3d(0,0,0));
               }
             }
           }
         }
         .boxs_detail1{
           background:url('../../assets/img/product3/value1.png') no-repeat center;
           background-size:100% 100%;
         }
         .boxs_detail2{
           background:url('../../assets/img/product3/value2.png') no-repeat center;
           background-size:100% 100%;
         }
         .boxs_detail3{
           background:url('../../assets/img/product3/value3.png') no-repeat center;
           background-size:100% 100%;
         }
       }
     }
     .gw_homefooterBox{
       height:160px;
     }
     /*服务内容*/
     .serviceCon{
       ul{
         li{
           float: left;
           width:590px;
           height:150px;
           border: 1px solid #D8D8D8;
           box-sizing: border-box;
           margin-bottom:35px;
           &:nth-child(2n+1){
             margin-right:20px;
           }
         }
         .icons{
           width:134px;
           padding-top:34px;
           p{
             font-size:18px;
             color:#000;
           }
         }
         .iconTxt{
           width:454px;
           padding:34px 34px 0 0;
           text-align: left;
           box-sizing: border-box;
           font-size:14px;
           color: #4A4A4A;
           span{
             display: inline-block;
           }
         }
         .icons1{
           i{
             display:inline-block;
             width:50px;
             height:44.5px;
             background:url('../../assets/product.svg') no-repeat -432px -184px;
           }
         }
         .icons2{
           i{
             display:inline-block;
             width:50px;
             height:44.5px;
             background:url('../../assets/product.svg') no-repeat -437px -254px;
           }
         }
         .icons3{
           i{
             display:inline-block;
             width:46px;
             height:42px;
             background:url('../../assets/product.svg') no-repeat -432px -321px;
           }
         }
         .icons4{
           i{
             display:inline-block;
             width:33px;
             height:41.7px;
             background:url('../../assets/product.svg') no-repeat -436px -387px;
           }
         }
       }
     }
     /*应用场景*/
     .scene{
       .boxs{
         width:390px;
         min-height: 100px;
         .boxs_top{
           height:160px;
           background: #E9E9E9;
           border-top-left-radius: 3px;
           border-top-right-radius: 3px;
           @include transtion_me(all,0.3s,linear);
           box-sizing: border-box;
           padding:22px 22px 22px 0;
           .icons{
             width:101px;
             i{
               display: inline-block;
               width:64px;
               height:65px;
               background:url('../../assets/product.svg') no-repeat -508px -183px;
             }
           }
           .iconTxt{
             width:289px;
             text-align: left;
             div{
               font-size:20px;
               color:#000;
             }
             p{
               font-size: 12px;
               color: #676767;
             }
           }
         }
         .boxs_mid{
           height:40px;
           background: #D8D8D8;
           @include transtion_me(all,0.3s,linear);
           div{
             width:130px;
             font-size: 14px;
             color: #4A4A4A;
             border-right:1px solid #979797;
             &:last-child{
               border:none;
             }
           }
         }
         .boxs_bottom{
           height:280px;
           box-sizing: border-box;
           border:1px solid #D8D8D8;
           border-top:none;
           border-bottom-left-radius: 2px;
           border-bottom-right-radius: 2px;
           padding:0 30px;
           div{
             width:329px;
             text-align: left;
             font-size: 14px;
             color: #4A4A4A;
             padding:25px 0;
             &:last-child{
               border:none;
             }
           }
           p{
             border-bottom: 1px solid #E9E9E9;
           }
         }
         @include transtion_me(all,0.3s,linear);
         &:hover{
           box-shadow: 2px 2px 10px #CAC8C8;;
           .boxs_top{
             background:#2F87FF;
             .icons{
               i{
                 background:url('../../assets/product.svg') no-repeat -508px -268px;
               }
             }
             .iconTxt{
               div,p{
                 color:#fff;
               }
             }
           }
           .boxs_mid{
             background:#3FA4F8;
              div{
                color:#fff;
                border-right-color: #fff;
              }
           }
         }
       }
     }
     #gw_animate3Box2{
       padding-top:35px;
     }
   }
</style>



// WEBPACK FOOTER //
// src/views/product/product3.vue